import { bus } from "../../packs/application";
import axios from "axios";
import queryString from "query-string";
import Utilities from "../../utilities";
import Question from "../../question";
import {
  localStorageGet,
  localStorageSet
} from "./../../safe-local-storage.js";

export const computed = {
  answeredCount() {
    return this.totalCount - this.questions.length - 1;
  },
  correctCount() {
    return this.answers.filter(a => a.isCorrect()).length;
  },
  wrongCount() {
    return this.answers.filter(a => !a.isCorrect()).length;
  },
  correctQuestions() {
    return this.answers.filter(a => a.isCorrect());
  },
  wrongQuestions() {
    return this.answers.filter(a => !a.isCorrect());
  },
  currentPercentage() {
    return (100 * (this.answeredCount + 1)) / this.totalCount;
  },
  answeredPercentage() {
    return (100 * this.answers.length) / this.totalCount;
  },
  questionsLeft() {
    return this.questions.length;
  }
};

export const methods = {
  testing() {
    return;
    this.withPause = false;
    while (this.currentQuestion) {
      // let selected;
      // this.currentQuestion.options.forEach(o => {
      //   if (o.is_correct) selected = o;
      // });
      this.currentQuestion.selectedOption = this.currentQuestion.options[0];
      // this.currentQuestion.selectedOption = selected;
      this.answerQuestion();
    }
  },
  initTest() {
    // get data from api, initTest variables
    this.answers = [];
    this.minutes =
      {
        1: 15,
        2: 30,
        3: 15,
        4: 15,
        6: 150,
        7: 150,
        8: 35
      }[this.options.category] || 30;
    this.averageSeconds = "-:--";
    this.loading = true;
    this.$refs.timer && this.$refs.timer.restart();

    const parsedParams = queryString.parse(location.search);
    console.log(parsedParams);

    let url =
      "https://www.drivepoint.gr/api/v1/fixed_test/new?" +
      `lang=${parsedParams.lang}&category=${parsedParams.category}&test_id=${
        parsedParams.test_id
      }`;

    axios.get(url).then(({ data }) => {
      this.questions = Question.parse({
        questions: data.questions,
        favorites: []
      });
      if (this.questions.length === 0) {
        this.screen = "emptyQuestions";
        return;
      }
      //set index for testdrive theme
      this.questions.forEach((q, i) => (q.index = i + 1));
      this.totalCount = this.questions.length;
      //set type depening on response
      this.setType(data.type);
      this.loading = false;
      this.screen = "test";
      this.nextQuestion();
    });
  },
  setType(type) {
    this.type = type;
    if ("normal lathon".indexOf(type) !== -1) {
      this.sendResults = true;
    } else if (type === "simulation") {
      this.sendResults = true;
      this.showToolbar = false;
      this.withPause = false;
      this.theme = "testdrive";
    } else {
      this.sendResults = false;
    }
  },
  restartTest() {
    this.screen = "test";
    //Utilities.scrollToId('vue-test-wrapper', 10);
    this.initTest();
  },
  answerQuestion() {
    this.answers.push(this.currentQuestion);
    if (!this.withPause || this.currentQuestion.isCorrect())
      this.nextQuestion();
    else if (this.withPause && !this.currentQuestion.isCorrect())
      bus.$emit("openModal");
  },
  skipQuestion() {
    // if true means it was answered incorrectly
    if (!this.currentQuestion.selectedOption)
      this.questions.push(this.currentQuestion);
    this.nextQuestion();
  },
  nextQuestion() {
    Utilities.scrollToId("vue-test-wrapper");
    // get next q or go to results
    if (!(this.currentQuestion = this.questions.shift())) {
      this.$refs.timer.pause();
      this.screen = "results";
      Utilities.scrollToTop();
      return;
    }
    if (this.currentQuestion.index === 1)
      this.preloadAssets(this.currentQuestion);
    this.preloadAssets(this.questions[0]);
  },
  preloadAssets(question) {
    if (!question) return;
    question.image && (new Image().src = question.image);
    if (!this.withSound) return;
    question.sound && new Audio(question.sound);
    question.options.forEach(option => {
      option.sound && new Audio(option.sound);
    });
  },
  playSound(sound) {
    if (!sound) this.stopSound();
    if (!this.withSound || !sound) return;
    this.$refs.audioPlayer.volume = 0.2;
    this.$refs.audioPlayer.src = sound;
    this.$refs.audioPlayer.play();
  },
  stopSound() {
    this.$refs.audioPlayer.pause();
    this.$refs.audioPlayer.src = "";
  },
  togglePause() {
    this.withPause = !this.withPause;
    // localStorage.defaultWithPause = this.withPause;
    localStorageSet("defaultWithPause", this.withPause);
  },
  toggleSound() {
    this.withSound = !this.withSound;
    // localStorage.defaultwithSound = this.withSound;
    localStorageSet("defaultWithSound", this.withSound);
  },
  toggleTheme() {
    this.theme = this.theme === "drivepoint" ? "testdrive" : "drivepoint";
    // localStorage.defaultTheme = this.theme;
    localStorageSet("defaultTheme", this.theme);
  }
};

export const watch = {
  answeredCount: function() {
    if (this.answeredCount === 0) return "-:--";
    this.averageSeconds = Utilities.secondsToTime(
      Math.floor(this.seconds / this.answeredCount)
    );
  },
  withSound() {
    if (!this.currentQuestion) return;
    this.stopSound();
  }
};

export const hooks = {
  created() {
    this.options = {
      category: "2", // b
      enableSound: false
    };
    // sets initial category and type
    this.withPause = localStorageGet("defaultWithPause") !== "false";
    // this.theme = localStorage.defaultTheme || "drivepoint";
    this.theme = localStorageGet("defaultTheme", "drivepoint");
    this.withSound = localStorageGet("defaultWithSound") === "true";
    this.initTest();
  }
};
